import { syncProjectFinishesApi } from '../api';
const finishesActions = {
    syncProjectFinishes: async ({ id, payload }, { setState }) => {
        try {
            const { data: res } = await syncProjectFinishesApi(id, { ids: payload });
            setState((state) => {
                if (state.project.data?.finishes) {
                    state.project.data.finishes = res;
                }
            });
            return res;
        }
        catch (error) {
            // @ts-ignore
            throw error?.response?.data;
        }
    },
};
export default finishesActions;
